module.exports = __webpack_public_path__ + "static/media/Electronics.e2873a16.svg";